import availabilityDisplayChannel from "../../../../javascript/channels/availability/availability_display_channel";

export default class extends Controller {
  connect() {
    this.replaceElementWith = this.replaceElementWith.bind(this)
    setTimeout(this.setUpChannelConnection.bind(this), 500)
  }

  setUpChannelConnection() {
    this.channel = this.channelCreator.init({ userID: this.userID, date: this.date, agencyID: this.agencyID })
    App.Helpers.listenToCustomEvent(document, this.updateEventName, this.replaceElementWith)
  }

  disconnect() {
    this.channel && this.channel.unsubscribe()
    App.Helpers.removeCustomEventListener(document, this.updateEventName, this.replaceElementWith)
  }

  replaceElementWith(event) {
    const { html, date, userID, agencyID } = event.detail
    if (date == this.date && userID == this.userID && (!this.agencyID || agencyID == this.agencyID)) {
      App.Helpers.replaceElement(this.element, html)
    }
  }

  get channelCreator() {
    return availabilityDisplayChannel
  }

  get updateEventName() {
    return "availability-display:update"
  }

  get userID() {
    return this.data.get("user-id")
  }

  get date() {
    return this.data.get("date")
  }

  get agencyID() {
    return this.data.get("agency-id")
  }
};



// WEBPACK FOOTER //
// ./app/components/calendars/assets/javascript/calendars-availability-display-controller.js